module.exports = __webpack_public_path__ + "static/dash-share-6cd254cf43cbd0d868ca49784cdb1c13.png";